import { render, staticRenderFns } from "./SettingsIndex.vue?vue&type=template&id=3117fe7a&"
import script from "./SettingsIndex.vue?vue&type=script&lang=js&"
export * from "./SettingsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports